export default {
  AC: 'Ascension',
  AD: 'Andorre',
  AE: '\u00c9mirats arabes unis',
  AG: 'Antigua-et-Barbuda',
  AI: 'Anguilla',
  AL: 'Albanie',
  AM: 'Arm\u00e9nie',
  AO: 'Angola',
  AQ: 'Antarctique',
  AR: 'Argentine',
  AS: 'Samoa am\u00e9ricaines',
  AT: 'Autriche',
  AU: 'Australie',
  AW: 'Aruba',
  AX: '\u00celes \u00c5land',
  AZ: 'Azerba\u00efdjan',
  BA: 'Bosnie-Herz\u00e9govine',
  BB: 'Barbade',
  BD: 'Bangladesh',
  BE: 'Belgique',
  BF: 'Burkina',
  BG: 'Bulgarie',
  BH: 'Bahre\u00efn',
  BI: 'Burundi',
  BJ: 'B\u00e9nin',
  BL: 'Saint-Barth\u00e9lemy',
  BM: 'Bermudes',
  BN: 'Brunei',
  BO: 'Bolivie',
  BQ: 'Pays-Bas carib\u00e9ens',
  BR: 'Br\u00e9sil',
  BS: 'Bahamas',
  BT: 'Bhoutan',
  BV: '\u00cele Bouvet',
  BW: 'Botswana',
  BY: 'Bi\u00e9lorussie',
  BZ: 'Belize',
  CA: 'Canada',
  CC: '\u00celes Cocos',
  CD: 'R\u00e9publique d\u00e9mocratique du Congo',
  CF: 'R\u00e9publique centrafricaine',
  CG: 'Congo',
  CH: 'Suisse',
  CI: "C\u00f4te d'Ivoire",
  CK: '\u00celes Cook',
  CL: 'Chili',
  CM: 'Cameroun',
  CO: 'Colombie',
  CR: 'Costa Rica',
  CV: 'Cap-Vert',
  CW: 'Cura\u00e7ao',
  CX: '\u00cele Christmas',
  CY: 'Chypre',
  CZ: 'R\u00e9publique tch\u00e8que',
  DE: 'Allemagne',
  DJ: 'Djibouti',
  DK: 'Danemark',
  DM: 'Dominique',
  DO: 'R\u00e9publique dominicaine',
  DZ: 'Alg\u00e9rie',
  EC: '\u00c9quateur',
  EE: 'Estonie',
  EG: '\u00c9gypte',
  EH: 'Sahara occidental',
  ER: '\u00c9rythr\u00e9e',
  ES: 'Espagne',
  ET: '\u00c9thiopie',
  FI: 'Finlande',
  FJ: 'Fidji',
  FK: '\u00celes Falkland',
  FM: 'Micron\u00e9sie',
  FO: 'F\u00e9ro\u00e9',
  FR: 'France',
  GA: 'Gabon',
  GB: 'Royaume-Uni',
  GD: 'Grenade',
  GE: 'G\u00e9orgie',
  GF: 'Guyane',
  GG: 'Guernesey',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GL: 'Groenland',
  GM: 'Gambie',
  GN: 'Guin\u00e9e',
  GP: 'Guadeloupe',
  GQ: 'Guin\u00e9e \u00e9quatoriale',
  GR: 'Gr\u00e8ce',
  GS: '\u00celes G\u00e9orgie du Sud et Sandwich du Sud',
  GT: 'Guatemala',
  GU: 'Guam',
  GW: 'Guin\u00e9e-Bissau',
  GY: 'Guyana',
  HK: 'Hong Kong',
  HM: '\u00celes Heard et McDonald',
  HN: 'Honduras',
  HR: 'Croatie',
  HT: 'Ha\u00efti',
  HU: 'Hongrie',
  ID: 'Indon\u00e9sie',
  IE: 'Irlande',
  IL: 'Isra\u00ebl',
  IM: '\u00cele de Man',
  IN: 'Inde',
  OI: "Territoire britannique de l'oc\u00e9an Indien",
  IQ: 'Irak',
  IS: 'Islande',
  IT: 'Italie',
  JE: 'Jersey',
  JM: 'Jama\u00efque',
  JO: 'Jordanie',
  JP: 'Japon',
  KE: 'Kenya',
  KG: 'Kirghizstan',
  KH: 'Cambodge',
  KI: 'Kiribati',
  KM: 'Comores',
  KN: 'Saint-Christophe-et-Ni\u00e9v\u00e8s',
  KR: 'Cor\u00e9e du Sud',
  KW: 'Kowe\u00eft',
  KY: '\u00celes Ca\u00efmans',
  KZ: 'Kazakhstan',
  LA: 'Laos',
  LB: 'Liban',
  LC: 'Sainte-Lucie',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Lituanie',
  LU: 'Luxembourg',
  LV: 'Lettonie',
  LY: 'Libye',
  MA: 'Maroc',
  MC: 'Monaco',
  MD: 'Moldavie',
  ME: 'Mont\u00e9n\u00e9gro',
  MF: 'Saint-Martin',
  MG: 'Madagascar',
  MH: '\u00celes Marshall',
  MK: 'Mac\u00e9doine',
  ML: 'Mali',
  MM: 'Myanmar/Birmanie',
  MN: 'Mongolie',
  MO: 'Macao',
  MP: '\u00celes Mariannes du Nord',
  MQ: 'Martinique',
  MR: 'Mauritanie',
  MS: 'Montserrat',
  MT: 'Malte',
  MU: 'Maurice',
  MV: 'Maldives',
  MW: 'Malawi',
  MX: 'Mexique',
  MY: 'Malaisie',
  MZ: 'Mozambique',
  NA: 'Namibie',
  NC: 'Nouvelle-Cal\u00e9donie',
  NE: 'Niger',
  NF: '\u00cele Norfolk',
  NG: 'Nigeria',
  NI: 'Nicaragua',
  NL: 'Pays-Bas',
  NO: 'Norv\u00e8ge',
  NP: 'N\u00e9pal',
  NR: 'Nauru',
  NU: 'Niue',
  NZ: 'Nouvelle-Z\u00e9lande',
  OM: 'Oman',
  PA: 'Panama',
  PE: 'P\u00e9rou',
  PF: 'Polyn\u00e9sie fran\u00e7aise',
  PG: 'Papouasie - Nouvelle-Guin\u00e9e',
  PH: 'Philippines',
  PK: 'Pakistan',
  PL: 'Pologne',
  PM: 'Saint-Pierre-et-Miquelon',
  PN: '\u00celes Pitcairn',
  PR: 'Porto Rico',
  PS: 'Palestine',
  PT: 'Portugal',
  PW: 'Palaos',
  PY: 'Paraguay',
  QA: 'Qatar',
  RE: 'La R\u00e9union',
  RO: 'Roumanie',
  RS: 'Serbie',
  RU: 'Russie',
  RW: 'Rwanda',
  SA: 'Arabie saoudite',
  SB: '\u00celes Salomon',
  SC: 'Seychelles',
  SE: 'Su\u00e8de',
  SG: 'Singapour',
  SH: 'Sainte-H\u00e9l\u00e8ne',
  SI: 'Slov\u00e9nie',
  SJ: 'Svalbard et Jan Mayen',
  SK: 'Slovaquie',
  SL: 'Sierra Leone',
  SM: 'Saint-Marin',
  SN: 'S\u00e9n\u00e9gal',
  SO: 'Somalie',
  SR: 'Surinam',
  SS: 'Soudan du Sud',
  ST: 'Sao Tom\u00e9-et-Principe',
  SV: 'El Salvador',
  SX: 'Sint-Maarten',
  SZ: 'Swaziland',
  TA: 'Tristan da Cunha',
  TC: '\u00celes Turks-et-Ca\u00efcos',
  TD: 'Tchad',
  TF: "Territoires d'outre-mer (France)",
  TG: 'Togo',
  TH: 'Tha\u00eflande',
  TJ: 'Tadjikistan',
  TK: 'Tok\u00e9laou',
  TL: 'Timor-Oriental',
  TM: 'Turkm\u00e9nistan',
  TN: 'Tunisie',
  TO: 'Tonga',
  TR: 'Turquie',
  TT: 'Trinit\u00e9-et-Tobago',
  TV: 'Tuvalu',
  TW: 'Ta\u00efwan',
  TZ: 'Tanzanie',
  UA: 'Ukraine',
  UG: 'Ouganda',
  UM: '\u00celes mineures \u00e9loign\u00e9es des \u00c9tats-Unis',
  US: '\u00c9tats-Unis',
  UY: 'Uruguay',
  UZ: 'Ouzb\u00e9kistan',
  VA: 'Saint-Si\u00e8ge/\u00c9tat de la Cit\u00e9 du Vatican',
  VC: 'Saint-Vincent-et-les-Grenadines',
  VE: 'Venezuela',
  VG: '\u00celes Vierges britanniques',
  VI: '\u00celes Vierges am\u00e9ricaines',
  VN: 'Vi\u00eat Nam',
  VU: 'Vanuatu',
  WF: 'Wallis-et-Futuna',
  WS: 'Samoa',
  XK: 'Kosovo',
  YE: 'Y\u00e9men',
  YT: 'Mayotte',
  ZA: 'Afrique du Sud',
  ZM: 'Zambie',
  ZW: 'Zimbabwe',
}
